import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useSettings } from '../../context/SettingsContext';
import { 
  DashboardIcon, 
  FileTextIcon, 
  MailIcon, 
  MessageCircleIcon,
  SettingsIcon, 
  LogOutIcon,
  LogoIcon,
  UsersIcon
} from '../../components/icons/Icons';
import './AdminLayout.css';

const AdminLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const { settings } = useSettings();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const navItems = [
    { path: '/admin', icon: DashboardIcon, label: 'Dashboard', exact: true },
    { path: '/admin/posts', icon: FileTextIcon, label: 'Blog Posts' },
    { path: '/admin/comments', icon: MessageCircleIcon, label: 'Comments' },
    { path: '/admin/messages', icon: MailIcon, label: 'Messages' },
    { path: '/admin/users', icon: UsersIcon, label: 'Users', adminOnly: true },
    { path: '/admin/settings', icon: SettingsIcon, label: 'Settings' }
  ];

  const isActive = (path, exact = false) => {
    if (exact) return location.pathname === path;
    return location.pathname.startsWith(path);
  };

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-header">
          <Link to="/" className="admin-logo">
            {settings.logo_light_url ? (
              <img src={settings.logo_light_url} alt="Logo" className="admin-logo-img" />
            ) : (
              <LogoIcon size={36} />
            )}
            <span>Admin</span>
          </Link>
        </div>

        <nav className="admin-nav">
          {navItems
            .filter(item => !item.adminOnly || user?.role === 'admin')
            .map(item => (
              <Link
                key={item.path}
                to={item.path}
                className={`admin-nav-item ${isActive(item.path, item.exact) ? 'active' : ''}`}
              >
                <item.icon size={20} />
                <span>{item.label}</span>
              </Link>
            ))}
        </nav>

        <div className="admin-sidebar-footer">
          <Link to="/admin/profile" className="admin-user">
            <div className="admin-user-avatar">
              {user?.username?.charAt(0).toUpperCase() || 'A'}
            </div>
            <div className="admin-user-info">
              <span className="admin-user-name">{user?.username}</span>
              <span className="admin-user-role">{user?.role}</span>
            </div>
          </Link>
          <button onClick={handleLogout} className="admin-logout-btn">
            <LogOutIcon size={20} />
            <span>Logout</span>
          </button>
        </div>
      </aside>

      <main className="admin-main">
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;
